export const ProjectInventoryItemAdjustmentTypeEnumValue = {
  AdditionalItem: 10,
  DealerInventory: 20,
  DistributorFullBoxExtraSupply: 30,
};

export const ProjectInventoryItemAdjustmentTypeEnum = [
  {
    value: ProjectInventoryItemAdjustmentTypeEnumValue.AdditionalItem,
    name: 'AdditionalItem',
    labelFrench: 'Article additionnel',
    labelEnglish: 'Additional item',
  },
  {
    value: ProjectInventoryItemAdjustmentTypeEnumValue.DealerInventory,
    name: 'DealerInventory',
    labelFrench: 'Article existant à retiré',
    labelEnglish: 'Existing Racking to subtract',
  },
  {
    value: ProjectInventoryItemAdjustmentTypeEnumValue.DistributorFullBoxExtraSupply,
    name: 'DistributorFullBoxExtraSupply',
    labelFrench: 'Ajout pour compléter la boîte du distributeur',
    labelEnglish: 'Added to complete distributor box',
  },
];

export default ProjectInventoryItemAdjustmentTypeEnum;
